import { Component, OnInit,Input } from '@angular/core';
import { CaseService } from '../shared/services/case.service';
import { LookupsService } from '../shared/services/lookups.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-archive-case',
  templateUrl: './archive-case.component.html',
  styleUrls: ['./archive-case.component.scss']
})
export class ArchiveCaseComponent implements OnInit {

  @Input() caseId: number;

  public reasons: any[] = [];
  isLoading: boolean = false;

  public selectedReason: any;
  public archiveReasonOther: string = '';

  constructor(
  public activeModal: NgbActiveModal,
  private caseService: CaseService,
  private lookupsService: LookupsService) {

    this.lookupsService.getArchiveReasons().subscribe(result => {
      this.reasons = result;
      this.selectedReason == 1;
    });

  }

  ngOnInit(): void {
  }

  cancel(){
    this.activeModal.dismiss();
  }

  save(){
    this.isLoading = true;
    var reasonOther = null;
    if(this.selectedReason == 2)
      reasonOther = this.archiveReasonOther

    var archiveDetails = {archiveReasonId: this.selectedReason, archiveReasonOther: reasonOther };

    this.caseService.archiveCase(this.caseId, archiveDetails).subscribe((response : any) => {

      this.activeModal.close(true);
      this.caseService.refreshCase.next();

      }, error => {

        var errorMessage = "Failed to archive case";
        if(error.error !== null && error.error.message !== undefined)
        {
          errorMessage = error.error.message;
        }

      });
  }

}
